import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

//Import css
import '../styles/userGuideModal.less';

// Import Images
import CorrectVastuFloorPlan from '../../../assets/images/building.png';
import WrongVastuFloorPlan from '../../../assets/images/floor.png';

export default function UserGuideModal({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) {
  const handleClose = () => {
    onClose();
  };

  const handleProceed = () => {
    onClose();
  };

  return (
    <>
      <Modal
        className="upload-floor-plan-guide-modal"
        title="Upload Your Home Layout"
        open={visible}
        footer={null}
        onCancel={handleClose}
      >
        <div className="body-sm description-text">
          Upload a picture of your house floor plan only. Don't upload plans
          that include hallways or other units.
        </div>

        <div className="banner-container">
          {/* Right Content */}
          <div className="banner-content banner-right">
            <CheckCircleOutlined className="banner-icon" />
            <img
              src={CorrectVastuFloorPlan}
              alt="Right"
              className="banner-image"
            />
            <span className="banner-text body-sm medium">Only House floor</span>
          </div>

          {/* Wrong Content */}
          <div className="banner-content banner-wrong">
            <CloseCircleOutlined className="banner-icon" />
            <img
              src={WrongVastuFloorPlan}
              alt="Wrong"
              className="banner-image"
            />
            <span className="banner-text body-sm medium">
              Building + other units
            </span>
          </div>
        </div>

        <div>
          <Button className="modal-btn" type="primary" onClick={handleProceed}>
            Got it
          </Button>
        </div>
      </Modal>
    </>
  );
}
